// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"lca-z","disabled":"mca-z","label":"nca-z"};